import { Timeline } from "../../Timeline";

export type JointCell = {
  type: "joint";
  id: string;
};

export function TroniconTimelineJoint() {
  return (
    <div className="ml-2 flex w-2 items-center">
      <Timeline type="joint" transitMode="walk" />
    </div>
  );
}
